import { render, staticRenderFns } from "./RechnungAdresse.vue?vue&type=template&id=26390564"
import script from "./RechnungAdresse.vue?vue&type=script&lang=js"
export * from "./RechnungAdresse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports